
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'Spinal_disorders_of_different_sites',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Neuro/Spinal_disorders_of_different_sites.vue